import { CommentsInformationFieldNames } from '@contracts/order/fields/CommentsInformationFields';
import { StringField } from '@src/permitField/PermitFields';
import type { StringSchema } from 'yup';
import * as yup from 'yup';

export class CommentsField extends StringField {
  public static fieldName: string = CommentsInformationFieldNames.Comments;
  public static validator: StringSchema = yup.string().optional();
}

export const commentsFields = {
  [CommentsField.fieldName]: CommentsField.validator,
};
